export enum Roles {
    Empty = '',
    Superadmin = 1,
    Trainer = 2,
    Athlete = 3
}

export type Role = {
    id: number;
    role: Roles;
}

export const RoleLabels: Record<Roles, string> = {
  [Roles.Empty]: "",
  [Roles.Superadmin]: "Superadmin",
  [Roles.Trainer]: "Trainer",
  [Roles.Athlete]: "Atleta"
};